import React from "react";
import { trackEvent } from "../../../utils/analytics";

const downloadShapeFile = () => {
  trackEvent("download Shapefile from FAQ");
  const url = "https://buscAR.terras.app/app/files/template_area.zip";
  window.open(url, "_blank");
};

export const questions_ptBR = [
  {
    name: "Acesso",
    questions: [
      {
        question: "Como faço para me cadastrar no BusCAR?",
        answer: (
          <p>
            Basta clicar em "Cadastre-se" em nossa página inicial. Insira seu
            nome, CPF, e-mail e senha e confirme "Declaro que li e aceito os
            Termos de Uso e a Política de Privacidade" após isto, clique no
            botão “Cadastrar"
          </p>
        )
      },
      {
        question:
          "Não recebi o e-mail de confirmação de cadastro. O que devo fazer?",

        answer: (
          <>
            <p>
              Os e-mails de confirmação de login e senha são enviados para o
              e-mail preenchido no cadastro. Alguns servidores de e-mail possuem
              configurações anti-spam.
            </p>
            <p>
              Essas configurações garantem que você não receberá mensagens
              indesejáveis em sua caixa postal. Na Internet, algumas pessoas
              enviam mensagens de propaganda, correntes, entre outras, sem
              autorização do destinatário. O anti-spam previne que isto não
              aconteça com sua caixa postal. Verifique se o e-mail chegou mas
              encontra-se na pasta "lixo eletrônico".
            </p>
          </>
        )
      },
      {
        question: "Esqueci minha senha. O que devo fazer?",

        answer: (
          <>
            <p>
              Para recuperar sua senha e continuar a utilizar os serviços do
              BusCAR, você deverá clicar na opção “Esqueceu sua senha?” na área
              de login na página inicial do BusCAR e inserir seu e-mail. Aguarde
              o e-mail de redefinição de senha.
            </p>
          </>
        )
      },
      {
        question:
          "Qual o tamanho da senha e como posso tornar minha senha mais forte?",

        answer: (
          <>
            <p>
              Ao criar uma nova senha, certifique-se de que ela tenha pelo menos
              seis caracteres. Tente usar uma combinação complexa de no mínimo
              seis números, letras e pontuações. Se a senha inserida não for
              forte o suficiente, tente combinar letras maiúsculas e minúsculas
              ou tornar a senha maior.
            </p>
          </>
        )
      }
    ]
  },

  {
    name: "Recursos e Consultas",

    questions: [
      {
        question: "Como informo um CPF ou CNPJ para consulta no sistema?",

        answer: (
          <p>
            Ao acessar o sistema, informe os números do CPF ou CNPJ na caixa de
            inserção de dados abaixo de "CPFs/CNPJs". Ao inserir os números
            válidos do CPF ou CNPJ clique no botão "enter" no seu teclado do seu
            computador.
          </p>
        )
      },
      {
        question: "Posso informar mais de um CPF ou CNPJ?",

        answer: (
          <p>
            Sim. Você pode informar quantos CPFs ou CNPJs forem de interesse da
            sua consulta. Ao inserir um CPF ou CNPJ clique no botão "enter" no
            seu teclado do seu computador e ficará habilitado o campo para
            inserção de outros dados.
          </p>
        )
      },
      {
        question: "Como faço para excluir um CPF ou CNPJ?",

        answer: (
          <p>
            Ao inserir um CPF ou CNPJ válido, o mesmo ficará será apresentado na
            caixa de inserção de dados com a letra "x" ao lado. Clique na letra
            "x" e os dados do CPF ou CNPJ serão excluídos.
          </p>
        )
      },
      {
        question:
          "Quais os formatos aceitos pelo sistema para consulta da área de interesse?",
        answer: (
          <>
            <p>Você pode enviar dois formatos de arquivo:</p>
            <ul>
              <li>
                Arquivo no formato Shapefile, zipado (
                <button className="link-button" onClick={downloadShapeFile}>
                  Baixar Modelo
                </button>
                )
              </li>
              <li>
                Arquivo no formato do SICAR Nacional, zipado (O SICAR é o
                sistema de CAR - Cadastro Ambiental Rural - do Serviço Florestal
                Brasileiro)
              </li>
            </ul>
          </>
        )
      },
      {
        question: "Como envio um arquivo para o sistema?",
        answer: (
          <>
            <p>
              Você precisará ter o arquivo em um dos formatos aceitos salvos em
              seu computador. Clique em "Adicionar Arquivo" será aberta uma
              caixa de interação do seu sistema operacional, escolha o arquivo
              para envio e clique em enviar.
            </p>

            <p>
              Aguarde enquanto o sistema processa o arquivo. Caso seja realizado
              com sucesso o processamento, será apresentado na tela do sistema
              um mapa, área total e município referentes ao arquivo enviado.
            </p>
            <p>
              Caso o arquivo enviado não seja suportado pelo sistema, aparecerá
              a mensagem "Tipo de arquivo não suportado".
            </p>
          </>
        )
      },
      {
        question:
          "Posso enviar mais de um arquivo shapefile ou CAR para o sistema?",
        answer: <p>Não. Apenas é possível enviar um arquivo por consulta.</p>
      },
      {
        question: "Como faço para excluir uma área enviada ao  sistema?",
        answer: (
          <p>
            Após realizar o envio do arquivo referente a área de interesse para
            consulta ao sistema e o processando ocorrendo com sucesso, será
            apresentado um botão "remover arquivo" clique nele que o arquivo
            será excluído, assim ficando disponível o envio de um novo arquivo.{" "}
          </p>
        )
      },
      {
        question:
          "Posso realizar uma consulta apenas informando um CPF ou CNPJ?",
        answer: (
          <p>
            Sim. Ao inserir os dados de CPF e CNPJ, clique no botão "continuar".
            A consulta será realizada sem a área de interesse, apenas com os
            dados de CPF ou CNPJ informados.
          </p>
        )
      },
      {
        question:
          "Posso realizar uma consulta apenas informando uma área de interesse?",
        answer: (
          <p>
            Sim. Ao enviar um arquivo de área para o sistema, clique no botão
            "continuar". A consulta será realizada apenas para área de interesse
            informada.
          </p>
        )
      },
      {
        question:
          "Encaminhei as informações para o sistema, como gero a consulta?",
        answer: (
          <>
            <p>
              Após informar os dados de CPF ou CNPJ ou enviar um arquivo de área
              e clicar no botão "continuar". Será aberta uma nova tela. Nela
              você terá duas opções:
            </p>
            <ul>
              <li>
                <span className="bold">Executar:</span> clicando nesta opção
                você será cobrado e terá acesso aos resultados da consulta.
              </li>
              <li>
                <span className="bold">Salvar:</span> clicando nesta opção os
                dados informados e arquivo enviado ficarão salvos no sistema
                para consulta futura. Você não será cobrado, porém não terá
                acesso aos resultados da consulta.
              </li>
            </ul>
          </>
        )
      },
      {
        question: "Os dados dos critérios analisados são de quais fontes?",

        answer: (
          <p>
            Todos os dados apresentados nos resultados das consultas realizadas
            no sistema são coletados de base de dados públicas oficiais.
          </p>
        )
      },
      {
        question: "Como faço para gerar um arquivo para impressão da consulta?",

        answer: (
          <p>
            Após executar uma consulta será aberta uma nova tela com os dados
            informados e área encaminhada. Clique no botão "exportar em pdf" e
            será aberta uma nova tela com o documento em formato em .PDF da sua
            consulta para impressão.
          </p>
        )
      }
    ]
  },
  {
    name: "Pagamentos",
    questions: [
      {
        question: "Quais são as formas de pagamento?",
        answer: (
          <p>
            O pagamento do seu plano pode ser feito por meio de boleto bancário
            ou cartão de crédito Visa ou MasterCard. Não aceitamos
            transferências bancárias.
          </p>
        )
      },
      {
        question: "Quanto tempo demora a liberação do meu plano?",
        answer: (
          <>
            <p>
              Boleto bancário: A liberação do pagamento poderá ocorrer em até 1
              dia útil após o processamento bancário.
            </p>
            <p>
              Cartão de crédito: A liberação do pagamento ocorre em até 30
              minutos, sujeito à análise da operadora.
            </p>
          </>
        )
      },
      {
        question: "O pagamento é seguro?",
        answer: (
          <p>
            Sim. A Terras utiliza o serviço da empresa Pagar.me para o
            processamento de pagamento melhores práticas de segurança dos seus
            dados, como criptografia e sistema antifraude. Em momento algum
            iremos lhe encaminhar algum entraremos em contato com você por
            mensagem ou telefone lhe enviando algum link de pagamento. Caso isso
            ocorra, favor nos informe.
          </p>
        )
      },
      {
        question: "Não tenho impressora para imprimir o boleto. O que faço?",
        answer: (
          <p>
            Neste caso, basta anotar a numeração do boleto referente o código de
            barras que encontra-se na parte superior da ficha de compensação.
            Esse número pode ser utilizado para pagamento em uma casa lotérica,
            correios ou pelo seu internet banking.
          </p>
        )
      },
      {
        question: "Qual o município que a nota fiscal será emitida?",
        answer: (
          <p>
            A Nota Fiscal de Serviços Eletrônica (NFS-e) será emitida pelo
            secretária de finanças de Belém-PA, município sede da Terras App
            Solutions.
          </p>
        )
      },
      {
        question: "Qual o tempo para eu receber a nota fiscal?",
        answer: (
          <p>
            Você receberá primeiramente em Recibo Provisório de Serviços (RPS),
            este documento é um intermediário à geração da NFS-e. Dentro do
            prazo do munícipio de Belém-PA o RPS será convertido em NFS-e em até
            10 (dez) dias corridos.
          </p>
        )
      },
      {
        question: "Como irei receber a minha nota fiscal?",
        answer: (
          <p>Ela será encaminhada para o seu e-mail cadastrado no sistema.</p>
        )
      },
      {
        question: "Não recebi a minha nota fiscal no meu e-mail, o que faço?",
        answer: (
          <p>
            Entre em contato conosco por telefone: +55 (91) 3204-2940 ou por
            e-mail: financeiro@terras.agr.br
          </p>
        )
      }
    ]
  }
];
